<template>
    <div class="text-center">
      <v-dialog v-model="dialog" max-width="550" persistent>
        <v-card>
          <v-card-title class="text-h6 blue darken-3 white--text">
            Volver a subir el comprobate de pago
          </v-card-title>
  
          <v-card-text> 
            <div v-if="xins.estudiante">
              <p class="mb-0">
                <b> Estudiante: </b>
                {{ xins.estudiante.nombres }} {{ xins.estudiante.pri_apellido }} {{ xins.estudiante.seg_apellido }}
              </p>
              <p class="my-0">  <b> Documento: </b> {{ xins.estudiante.num_doc }} </p>
              <p class="my-0">  <b> Correo: </b> {{ xins.estudiante.email }} </p>
              <p class="my-0">  <b> Telefono 1: </b> {{ xins.estudiante.telefono1 }} </p>
              <p class="my-0">  <b> Domicilio: </b> {{ xins.estudiante.domicilio }} </p>
              <p class="my-0">  <b> Fecha nac: </b> {{ xins.estudiante.fecha_nac }} </p> 
            </div>
            <ComprobantePago v-show="false" ref="refComprobantePago" @comprobante-guardado="handleComprobanteGuardado($event,'comprobantex')" />
          </v-card-text>
  
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green" outlined @click="enviar()" :loading="loading"> Aceptar </v-btn>
            <v-btn color="red" outlined @click="cerrar()"> Cerrar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>
  
<script>
import ComprobantePago from '@/components/ComprobantePago.vue';
import gql from 'graphql-tag';
import xaxios from '@/xaxios';

export default {
  components:{ComprobantePago},
    data() {
        return { 
            dialog: false,
            loading: false,
            xins: {},
            comprobanteData:{},
        };
    },
    methods: {
        async openmodal(p) { 
          this.xins = p
          this.dialog = true; 
          this.getsededata(this.xins.programa.sede.id) 
        }, 
        async getsededata(sede_id){
          let sede_data = {}
          this.loading = true
          const sql = gql`query{getSede(id: ${sede_id}) { id, nombre, cuentasBancarias{ id, nombre, descripcion, nro, estado } ${''}}}`;
          const res = await this.$apollo.query({ query: sql }).then(({ data }) => data ).catch(e=>e)
          this.loading = false
          if(res && res.getSede) sede_data = res.getSede;
          window.console.log('sedeeee', sede_data); 

          this.$nextTick(() => { 
            this.$refs.refComprobantePago.setCuentasBancarias(sede_data?.cuentasBancarias);
          });
        },
        handleComprobanteGuardado(data, tipo){
          if(tipo == 'comprobantex'){
            this.comprobanteData.archivo = data.archivo
            this.comprobanteData.comentario = data.comentario
            this.comprobanteData.fechaPago = data.fechaPago
            this.comprobanteData.monto = data.monto
            this.comprobanteData.depositante = data.depositante
            this.comprobanteData.nrComprobante = data.nrComprobante
            this.comprobanteData.banco = data.banco
            this.comprobanteData.nroCuenta = data.nroCuenta
          }
          if (!data.archivo) {
            window.console.error("Error: No se encontró un archivo en data.archivo");
            return;
          }

          const reader = new FileReader();
          reader.readAsDataURL(data.archivo);
          reader.onload = () => {  // Usamos una arrow function para mantener el contexto de `this`
            if(tipo == 'comprobantex'){
              this.comprobanteData.archivoComprobante = reader.result.split(",")[1];
              this.comprobanteData.xbase64 = reader.result; 
            }
          };
          reader.onerror = (error) => {
            window.console.error("Error al convertir el archivo a Base64:", error);
          }; 
        },

        cerrar(){ 
          this.dialog = false;
        },
        async enviar(){ 
          if(!this.comprobanteData || !this.comprobanteData.xbase64){
            this.$root.$notify.show('Debe subir el comprobante de pago', { color: 'red', x: 'right' });
            return;
          } 
          this.$root.$notify.show('esta funcionalidad no se encuentra disponible', { color: 'red', x: 'right' });

          window.console.log('comprobanteData',this.comprobanteData, this.xins);

          let urldeuda = process.env.VUE_APP_API_REST + '/api/esam/comprobante-pago';
          const r = await xaxios.post(urldeuda).then
          window.console.log('r',r);
          
          
        }
    }
};
</script>
  